import React, { useState } from 'react';
import axios from 'axios';
import { setActiveProfile } from '../utils/profile';
export default function ProfileNameEditor({ profile }) {
  const [open, setOpen] = useState(false), [name, setName] = useState(''), [error, setError] = useState(''), [busy, setBusy] = useState(false);
  if (!profile?._id) return null;
  const save = async e => {
    e.preventDefault(); if (!name.trim() || busy) return; setBusy(true); setError('');
    try { const { data } = await axios.patch(`/api/profiles/${profile._id}`, { name: name.trim() }); setActiveProfile(data.profile || data); setOpen(false); }
    catch (err) { setError(err.response?.data?.message || 'Could not change your name.'); }
    finally { setBusy(false); }
  };
  return open ? <form className="profile-name-editor" onSubmit={save} aria-label="Edit profile name" aria-busy={busy}>
    <label className="profile-name-field"><span>Profile name</span><input autoFocus required maxLength={60} disabled={busy} value={name} onChange={e => setName(e.target.value)} /></label>
    {error && <p className="profile-name-error" role="alert">{error}</p>}
    <div className="profile-name-actions">
      <button className="profile-resume-btn" disabled={busy || !name.trim()} type="submit">{busy ? 'Saving...' : 'Save name'}</button>
      <button className="profile-reset-btn profile-name-secondary" disabled={busy} type="button" onClick={() => setOpen(false)}>Cancel</button>
    </div>
  </form> : <button className="profile-reset-btn profile-name-secondary profile-name-edit" type="button" onClick={() => { setName(profile.name); setError(''); setOpen(true); }}>Edit name</button>;
}
